"use client";

import { useState } from "react";
import { useToast } from "../components/context/ToastContext";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { EnumStatusConsultation, IHistory } from "../interfaces/history";
import { concluirConsulta, fetchHistory, alterarStatusConsulta } from "../services/historyService";

export function useHistory(initialPage: number = 1) {
  const showToast = useToast();
  const queryClient = useQueryClient();

  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(initialPage);
  const [filters, setFilters] = useState({
    protocol: "",
    document: "",
    startDate: "",
    endDate: "",
    status: "",
    deviceId: "",
    geoLocalizacao: "",
    ip: "",
    cpf: "",
    deviceIp: "",
  });
  const [appliedFilters, setAppliedFilters] = useState(filters);
  const [showConcludeModal, setShowConcludeModal] = useState(false);
  const [pendingCompany, setPendingCompany] = useState<IHistory | null>(null);

  const [showChangeStatusModal, setShowChangeStatusModal] = useState(false);
  const [companyToChange, setCompanyToChange] = useState<IHistory | null>(null);

  const HistoryQuery = useQuery<
    { items: IHistory[]; totalCount: number },
    Error,
    { History: IHistory[]; totalPages: number }
  >({
    queryKey: ["History", pageNumber, appliedFilters],
    queryFn: () => fetchHistory(pageNumber, filters),
    select: (apiResponse: any) => {
      console.log("apiResponse", apiResponse);
      const items = apiResponse.data.data || [];
      const totalPages = apiResponse.data.totalPages || 1;
      return { History: items, totalPages };
    },
    //@ts-ignore
    onError: () => {
      showToast("error", "Erro ao buscar.");
    },
  });

  const mutationConcluir = useMutation<void, Error, string>({
    mutationFn: (protocol: string) => concluirConsulta(protocol),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["History"] });
      showToast("success", "Sucesso ao concluir item");
      setShowConcludeModal(false);
    },
    onError: () => {
      showToast("error", "Erro ao concluir item.");
    },
  });

  const openConcludeModal = (company: IHistory) => {
    setPendingCompany(company);
    setShowConcludeModal(true);
  };

  const confirmConclude = () => {
    if (pendingCompany) {
      mutationConcluir.mutate(pendingCompany.protocol || "");
    }
  };

  const openChangeStatusModal = (company: IHistory) => {
    setCompanyToChange(company);
    setShowChangeStatusModal(true);
  };

  const mutationAlterarStatus = useMutation<void, Error, { protocol: string; status: EnumStatusConsultation }>({
    mutationFn: ({ protocol, status }) => alterarStatusConsulta(protocol, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["History"] });
      showToast("success", "Status alterado com sucesso");
      setShowChangeStatusModal(false);
      setCompanyToChange(null);
    },
    onError: () => {
      showToast("error", "Erro ao alterar o status.");
    },
  });

  const confirmAlterarStatus = (status: EnumStatusConsultation) => {
    if (!companyToChange?.protocol) return;
    mutationAlterarStatus.mutate({ protocol: companyToChange.protocol, status });
  };

  return {
    History: HistoryQuery.data?.History || [],
    totalPages: HistoryQuery.data?.totalPages || 1,
    isLoading: HistoryQuery.isLoading,

    search,
    setSearch,
    pageNumber,
    setPageNumber,

    filters,
    setFilters,
    setAppliedFilters,
    refetchHistory: HistoryQuery.refetch,
    mutationConcluir,
    confirmConclude,
    openConcludeModal,
    showConcludeModal,
    setShowConcludeModal,
    pendingCompany,

    openChangeStatusModal,
    showChangeStatusModal,
    setShowChangeStatusModal,
    companyToChange,
    confirmAlterarStatus,
    isChangingStatus: mutationAlterarStatus.status === "pending",
  };
}
